import axios from 'axios';

interface AddQuestionParams {
  noteId: string;
  name: string;
  text: string;
}

interface AddQuestionResponse {
  result_code: number;
  data: {
    message: string;
    question_id: number;
  };
  lang: string;
  userID: string | null;
}

export async function addQuestion({ noteId, name, text }: AddQuestionParams): Promise<AddQuestionResponse> {
  // Используем Next.js API роут вместо прямого обращения к внешнему API
  const response = await axios.post<AddQuestionResponse>('/api-v2/add-question', {
    noteId,
    name,
    text,
  }, {
    headers: {
      'Content-Type': 'application/json',
    }
  });

  return response.data;
} 